export const SOFTWARE_STUDIO_MAIN_DATA: Record<string, any> = {
  name: "bHaptics Studio",
  summary: [
    {
      head: "Key Features",
      list: [
        "Use the bHaptics App on your mobile device connected to the same network as PlayStation 5 to access supported content for TactSuit and PSVR2.",
      ],
    },
  ],
};

export const SOFTWARE_STUDIO_FEATURES_DATA: Record<any, any> = [
  {
    title: "Create Audio-To-Haptic Profiles for Customized Experience",
    body: "Configure frequency thresholds and customize feedback point mapping to create your own haptic profiles and enjoy customized Audio-to-Haptic experience.",
    info: [
      "Frequency band selection",
      "Select a sound volume range",
      "Real-time Audio & Feedback monitoring",
    ],
  },
  {
    title: "Share Audio-to-Haptic Profiles",
    body: "Use your Audio-to-Haptic profiles when using the Audio-to-Haptic feature on bHaptics Player and share your profiles with other users.",
    info: [
      "Create and upload profiles to bHaptics Player to share with other users",
    ],
  },
];

export const SOFTWARE_STUDIO_TITLE_IMG_DATA: {
  head: string;
  body: string;
  caution?: string;
} = {
  head: "bHaptics Studio",
  body: "Use bHaptics Studio to configure audio-based haptic frequency settings and create your own audio-based haptic profiles.",
};
